import { LocalizedString, localizedStringFromMap } from './LocalizedString';

export interface JourneyStepConfigOverride {
  rounds?: number;
  breathDuration?: {
    inhaleMs: number;
    fullLungsRetentionMs: number;
    exhaleMs: number;
    emptyLungsRetentionMs: number;
  } | null;
  breathsOnFirstRound?: number | null;
  incrementBetweenRounds?: boolean | null;
}

export interface JourneyStepTechnique {
  breathworkId: string;
  configOverride?: JourneyStepConfigOverride | null;
  transitionAudioKey?: string | null;
}

export interface JourneyStep {
  id: string;
  position: number;
  title: LocalizedString;
  description: LocalizedString;
  techniques: JourneyStepTechnique[];
  estimatedDurationMin?: number | null;
}

function breathDurationFromJson(
  json: Record<string, unknown>,
): JourneyStepConfigOverride['breathDuration'] {
  return {
    inhaleMs: json['inhaleMs'] as number,
    fullLungsRetentionMs: json['fullLungsRetentionMs'] as number,
    exhaleMs: json['exhaleMs'] as number,
    emptyLungsRetentionMs: json['emptyLungsRetentionMs'] as number,
  };
}

function configOverrideFromJson(
  json: Record<string, unknown>,
): JourneyStepConfigOverride {
  return {
    ...(json['rounds'] != null && { rounds: json['rounds'] as number }),
    breathDuration:
      json['breathDuration'] != null
        ? breathDurationFromJson(
            json['breathDuration'] as Record<string, unknown>,
          )
        : null,
    ...(json['breathsOnFirstRound'] != null && { breathsOnFirstRound: json['breathsOnFirstRound'] as number }),
    ...(json['incrementBetweenRounds'] != null && { incrementBetweenRounds: json['incrementBetweenRounds'] as boolean }),
  };
}

function techniqueFromJson(json: Record<string, unknown>): JourneyStepTechnique {
  return {
    breathworkId: json['breathworkId'] as string,
    configOverride:
      json['configOverride'] != null
        ? configOverrideFromJson(
            json['configOverride'] as Record<string, unknown>,
          )
        : null,
    transitionAudioKey:
      (json['transitionAudioKey'] as string | null) ?? null,
  };
}

export function journeyStepFromJson(
  json: Record<string, unknown>,
): JourneyStep {
  return {
    id: json['id'] as string,
    position: json['position'] as number,
    title: localizedStringFromMap(json['title'] as Record<string, unknown>),
    description: localizedStringFromMap(
      json['description'] as Record<string, unknown>,
    ),
    techniques: ((json['techniques'] as Record<string, unknown>[] | undefined) ?? []).map(
      techniqueFromJson,
    ),
    estimatedDurationMin:
      (json['estimatedDurationMin'] as number | null) ?? null,
  };
}
